import React, { useEffect, useState } from "react";
import styles from "./upcoming-events.module.css";
import CustomCard from "../../../../components/custom-card/custom-card";
import GradientButton from "../../../../components/gradient-tick-button/gradient-tick-button";
import CustomTable from "../../../../common/custom-table/custom-table";
import { Spin } from "antd";
import { getEventsList } from "../../../../services/dashboard";
import { formattedDateWithDay, PAGE_LIMIT } from "../../../../constants/common";

const UpcomingEventsCard = () => {
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setTableData([]);
    fetchEventsList();
  }, []);

  const fetchEventsList = async () => {
    try {
      setLoading(true);
      const payload = {
        page: 1,
        pageSize: PAGE_LIMIT,
        status: "Upcoming",
      };
      const resp = await getEventsList(payload);
      const responceData = resp?.data;

      const formatted = (responceData?.data || []).map((row) => ({
        ...row,
        dateDay: `${row?.date} (${row?.day_of_week})`,
      }));

      setTableData(formatted);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      dataIndex: "reason",
      key: "reason",
      render: (text) => <span style={{ cursor: "pointer" }}>{text}</span>,
    },
    {
      dataIndex: "dateDay",
      key: "dateDay",
      render: (text) => (
        <span style={{ cursor: "pointer" }}>{formattedDateWithDay(text)}</span>
      ),
    },
  ];

  return (
    <CustomCard style={{ height: 300 }}>
    
       <div className={styles.topBar}>
        <span className={styles.card_heading}>Upcoming Events</span>
        <div style={{ marginLeft: "auto" }}>
          <GradientButton />
        </div>
      </div>
    
       <div className={styles.tableWrapper}>
        <Spin spinning={loading}>
          <CustomTable
            columns={columns}
            dataSource={tableData}
            showHeader={false}
            pagination={false}
          />
        </Spin>
      </div>
    </CustomCard>
  );
};

export default UpcomingEventsCard;
